import { fetchApi } from '@/config/axiosSetting';
import { addBodyWagesQueryParams } from '@/modules/adjusterReportModules/Insurer-information/queries/patchAddBodyWegas/patchAddBodyWegasQuery.type';

export const addBodyWegesQueryFunction = (params: addBodyWagesQueryParams) =>
  fetchApi.post(
    `body/reports/${params?.id}/accident_users/damaged/adjusting/wages/`,
    params?.data,
  );
